import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import axiosInstance from 'axiosConfig';
import { Toast } from 'components';
import { TOAST_TYPES_ENUM } from 'enums';
import { queryClient } from 'App';

export interface CheckList {
  required: boolean;
  text: string;
}


const useUpdateCheckList = (
  options?: UseMutationOptions<any, Error, any>
) => {
  return useMutation({
    ...options,
    mutationKey: ['updateCheckList'],
    mutationFn: async (data) => {
      return axiosInstance.put(`/check-list`, data).then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: 'Aktualizacja checklisty...',
        type: TOAST_TYPES_ENUM.LOADING,
        id: 'update-checklist',
      });
      if (options && options.onMutate) {
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: 'Checklista zaktualizowana pomyślnie.',
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: 'update-checklist',
      });
      queryClient.invalidateQueries({ queryKey: ['measurementTypes'] });
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: 'Błąd podczas aktualizacji checklisty.',
        type: TOAST_TYPES_ENUM.ERROR,
        id: 'update-checklist',
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default useUpdateCheckList;
